/**
 * Verified users API – lookup by DID or handle (SHXRE verified DB).
 * Same origin as Studio (e.g. https://shxre.social).
 */

import {STUDIO_API_BASE, getStudioAuthHeaders} from '#/lib/api/studio'

export type VerifiedUserType = 'individual' | 'business'

export interface VerifiedUser {
  did: string
  type: VerifiedUserType
  pds_handle: string
  custom_handle?: string | null
  display_name?: string | null
}

export async function fetchVerifiedUser(opts: {
  did?: string | null
  handle?: string | null
}): Promise<VerifiedUser | null> {
  const {did, handle} = opts
  if (!did && !handle) return null
  const params = new URLSearchParams()
  if (did) params.set('did', did)
  if (handle) params.set('handle', handle.replace(/^@/, ''))
  const url = `${STUDIO_API_BASE.replace(/\/$/, '')}/api/verified/lookup?${params.toString()}`
  const res = await fetch(url, {
    headers: getStudioAuthHeaders(),
  })
  if (!res.ok) return null
  const data = await res.json()
  if (data == null) return null
  return data as VerifiedUser
}

/**
 * Fetches all SHXRE verified user DIDs for discover feed injection.
 * Returns empty array on failure or when no verified users exist.
 */
export async function fetchVerifiedUsersList(): Promise<string[]> {
  try {
    const url = `${STUDIO_API_BASE.replace(/\/$/, '')}/api/verified/list`
    const res = await fetch(url, {
      headers: getStudioAuthHeaders(),
    })
    if (!res.ok) return []
    const data = await res.json()
    if (!Array.isArray(data)) return []
    return data.filter((d: unknown): d is string => typeof d === 'string')
  } catch {
    return []
  }
}
